import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const SinkbankMaster = createSlice({
  name: "SinkbankMaster",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    sink_bank_master: (state, action?: any) => {
      state.isLoading = true;
    },
    success_api_call_sink_bank_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_sink_bank_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    sink_bank_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
  },
});
export default SinkbankMaster.reducer;
export const {
  sink_bank_master,
  success_api_call_sink_bank_master,
  sink_bank_isSuccess,
  failure_api_call_sink_bank_master,
} = SinkbankMaster.actions;
